/**
 * PATH: apps/quote/src/components/builder/other-charges-section/types.ts
 * PURPOSE: Types, constants, and helpers for OtherChargesSection
 */

export interface OtherCharge {
  id: string
  category: string
  description: string
  quantity: number
  rate: number
  cost: number
  margin_percent: number
  chargeout: number
  is_deduction: boolean
  sort_order: number
}

export interface OtherChargesSectionProps {
  quoteId: string
  charges: OtherCharge[]
  isEditable: boolean
  onAddCharge?: (data: Partial<OtherCharge>) => void
  onUpdateCharge?: (id: string, data: Partial<OtherCharge>) => void
  onDeleteCharge?: (id: string) => void
}

export const CATEGORY_OPTIONS = [
  { value: 'pm_supervision', label: 'PM/Supervision', icon: '👔' },
  { value: 'qa_system', label: 'QA Plan/System', icon: '📋' },
  { value: 'mobilisation', label: 'Mobilisations & Inductions', icon: '🚚' },
  { value: 'freight', label: 'Freight & Deliveries', icon: '📦' },
  { value: 'material_handling', label: 'Material Handling', icon: '🏗️' },
  { value: 'insurance', label: 'Insurance', icon: '🛡️' },
  { value: 'travel', label: 'Travel', icon: '✈️' },
  { value: 'accommodation', label: 'Accommodation', icon: '🏨' },
  { value: 'escalation', label: 'Escalation Factor', icon: '📈' },
  { value: 'discount', label: 'Discount', icon: '💰', isDeduction: true },
  { value: 'other', label: 'Other', icon: '📝' },
] as const

export function formatCurrency(value: number): string {
  if (value < 0) {
    return `-$${Math.abs(value).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
  }
  return `$${value.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

export function getCategoryLabel(category: string): string {
  return CATEGORY_OPTIONS.find(c => c.value === category)?.label || category
}

export function getCategoryIcon(category: string): string {
  return CATEGORY_OPTIONS.find(c => c.value === category)?.icon || '📝'
}
